import { render, staticRenderFns } from "./placard_after_sal.vue?vue&type=template&id=8bc9fa08&scoped=true"
import script from "./placard_after_sal.vue?vue&type=script&lang=js"
export * from "./placard_after_sal.vue?vue&type=script&lang=js"
import style0 from "./placard_after_sal.vue?vue&type=style&index=0&id=8bc9fa08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc9fa08",
  null
  
)

export default component.exports